import React from 'react';

import './ToggleBackToCreator.css';
import { getTranslation } from '../../../assets/creator/translations';

const FileIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <path fill="#4A5DE2" fillRule="evenodd" d="M27.369 15H7.459l5.354-5.355a.999.999 0 1 0-1.415-1.414L3.633 16l7.767 7.77a.999.999 0 1 0 1.414-1.416L7.458 17h19.91a1 1 0 1 0 0-2" />
    </svg>
)

const ToggleBackToCreator = (props) => (
    <div className="toggle-creator" onClick={props.onClick} style={{display: "flex", cursor: "pointer"}}>
        <FileIcon/>
        <span className="toggle-creator__text">{getTranslation("BackCreator")}</span>
    </div>
);

export default ToggleBackToCreator;